export enum ConsolidatedLineItemCategory {
  StyleAndSize = 'style-and-size',
  ColorsAndMaterials = 'colors-and-materials',
  SidesAndEnds = 'sides-and-ends',
  CenterSection = 'center-section',
  LeftSection = 'left-section',
  RightSection = 'right-section',
  FrontSection = 'front-section',
  BackSection = 'back-section',
  DoorsAndWindows = 'doors-and-windows',
  Frameouts = 'frameouts',
  FlooringAndInterior = 'flooring-and-interior',
  AdditionalOptions = 'additional-options',
  AdditionalFees = 'additional-fees',
  AdditionalFeesIgnoreSection = 'additional-fees-ignore-section',
  AdditionalInformation = 'additional-information',
  Unknown = 'unknown',
}
